import Marquee from "react-fast-marquee";

const words = [
  "Her Şehre Hizmet",
  "Panel Çit",
  "Modern Bahçe Kapısı",
  "Ferforje Kapı",
  "Endüstriyel Sürgülü Kapı",
  "TS EN ISO 9001:2015",
  "Türkiye Geneli Teslimat",
  "Özel Tasarım & Ölçü",
];

export default function IndustrialMarquee() {
  return (
    <div className="bg-[#0A0A0A] text-white py-7 border-y border-black/5">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {words.map((w, i) => (
          <div key={i} className="flex items-center mx-7">
            <span className="font-display text-xl md:text-2xl font-medium tracking-tight text-white">
              {w}
            </span>
            <span className="ml-7 w-1 h-1 rounded-full bg-[#FF5A00]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
